var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('template-mail-form',{attrs:{"loading":_vm.loading,"templateMailData":_vm.templateMail,"formErrors":_vm.formErrors},on:{"templateMailSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }